module.exports = __webpack_public_path__ + "img/delete-note.e0880a63.svg";